/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PhoneNumber } from './PhoneNumber';
import type { ReferencePerson } from './ReferencePerson';
export type ProfileDto = {
    id?: string;
    citizenId?: string;
    passportNumber?: string;
    firstName?: string;
    lastName?: string;
    citizenAddress?: string;
    currentAddress?: string;
    occupation?: string;
    workPlace?: string;
    workAddress?: string;
    email?: string;
    lineId?: string;
    facebookUrl?: string;
    facebookName?: string;
    instagramUrl?: string;
    instagramName?: string;
    tiktokUrl?: string;
    tiktokName?: string;
    firstReferencePersonFirstName?: string;
    firstReferencePersonLastName?: string;
    firstReferencePersonRelation?: string;
    firstReferencePersonPhoneNumber?: string;
    secondReferencePersonFirstName?: string;
    secondReferencePersonLastName?: string;
    secondReferencePersonRelation?: string;
    secondReferencePersonPhoneNumber?: string;
    type?: ProfileDto.type;
    phoneNumbers?: Array<PhoneNumber>;
    referencePersons?: Array<ReferencePerson>;
};
export namespace ProfileDto {
    export enum type {
        ONLINE = 'ONLINE',
        OFFLINE = 'OFFLINE',
    }
}

